import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useWebPush } from '../hooks/useWebPush';

/** Registers Web Push when the user is authenticated. */
export function WebPushRegistration(): null {
  const { isAuthenticated } = useAuth();
  const { supported, subscribed, subscribe } = useWebPush(isAuthenticated);

  useEffect(() => {
    if (!isAuthenticated || !supported || subscribed) return;
    if (Notification.permission !== 'granted') return;
    void subscribe();
  }, [isAuthenticated, subscribe, subscribed, supported]);

  return null;
}
